import type { IconData } from '@stacksjs/iconify-core'

export const setForward: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13.82 9.523a.976.976 0 0 0-.324-1.363L3.574 2.128a1.03 1.03 0 0 0-.535-.149c-.56 0-1.013.443-1.013.99V15.03c0 .185.053.366.153.523c.296.464.92.606 1.395.317l9.922-6.031c.131-.08.243-.189.325-.317zm.18 2.341l-9.355 5.687c-1.425.867-3.3.44-4.186-.951A2.9 2.9 0 0 1 0 15.03V2.97C0 1.329 1.36 0 3.04 0c.567 0 1.123.155 1.605.448L14 6.135V2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zM16 2v14h2V2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default setForward
